// extracted by mini-css-extract-plugin
module.exports = {"questionSelection":"_5l6L61xJvbbBW7Vz","floatingLabelWrapper":"_2JHzVmHlZ38ZOSyF","floatingLabel":"TiuHnMd67tTyZW7S","error":"_18BaVh75PxQnnlr8","required":"_3M9MNqgEeHJysYee"};